import { redirect } from "@tanstack/react-router";
import {
    type UrlSearchParams,
    UrlSearchParamsSchema,
} from "@/features/discovery";
import { canonicalBrowseDogsSearch } from "./browse-dogs";

export const browseDogsSearchRoute = {
    validateSearch: UrlSearchParamsSchema,
    beforeLoad: ({ search }: { search: UrlSearchParams }) => {
        throw redirect(canonicalBrowseDogsSearch(search));
    },
};
